import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const masVpas = response?.[0]?.data
  const mmsVpas = response?.[1]?.data
  const allVpas = masVpas.concat(mmsVpas)
  const sortedVpas = allVpas.sort()
  const retData: any = []
  const getStatus = (item: any) => {
    const vpaExists = (arr: any) => {
      const retArr = arr.filter((obj: any) => obj.vpa === item.vpa)
      return retArr.length > 0
    }
    if (vpaExists(masVpas) && vpaExists(mmsVpas)) {
      if (item.disabled) {
        return 'Added in MMS (Disabled)'
      } else {
        return 'Added in MMS'
      }
    }
    if (vpaExists(masVpas) && !vpaExists(mmsVpas)) {
      return 'Fetched from MAS'
    }
    if (!vpaExists(masVpas) && vpaExists(mmsVpas)) {
      return 'Deleted from MAS'
    }
  }
  sortedVpas.map((item: any) => {
    const retItem = {
      id: item.mindgateId,
      vpa: item.vpa,
      mindgateId: item.mindgateId,
      status: getStatus(item),
    }
    const itemExists = retData.filter((obj: any) => obj.vpa === item.vpa)?.length > 0
    !itemExists && retData.push(retItem)
  })
  return retData
}

const getAllVpas = (tokens: any) => {
  const masRequest: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getMasVpas),
    method: 'GET',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
  }

  const mmsRequest: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getMmsVpas),
    method: 'GET',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
  }

  return Promise.all([executeRequest(masRequest), executeRequest(mmsRequest)]).then((data) => {
    return responseParser(data)
  })
}

export { getAllVpas }
